declare namespace $ {

	export class $mol_icon_hamburger extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=hamburger.view.tree.d.ts.map